import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';
import { CategoryPrice } from '../models/category-price';
import { MatTableDataSource } from '@angular/material/table';

@Injectable({
  providedIn: 'root'
})
export class AnnuityCatPriceService {

  public objectImage: any = null; // store input file for avatar
  public storedImage: any; // store url image for local preview

  private itemDoc: AngularFirestoreDocument<CategoryPrice>;
  private item: Observable<CategoryPrice>;

  public productCatPricePartnerTrueDataSource: MatTableDataSource<any>;
  public productCatPricePartnerFalseDataSource: MatTableDataSource<any>;

  constructor(
    private db: AngularFirestore,
    private snackBar: SnackBarIconService) { }

  select() {
    return this.db.collection<CategoryPrice>('sbccv_product_cat_price', ref => ref.orderBy('name', 'asc')).snapshotChanges();
  }

  loadCategoryPrices(product_id: any, lot_id: any) {

    console.log(">>>> product_id: " + product_id)
    console.log(">>>> lot_id: " + lot_id)

    return this.db.collection<CategoryPrice>('sbccv_product_cat_price', ref => ref
      .where('product_id', '==', product_id)
      .where('lot_id', '==', lot_id)).snapshotChanges()
      .subscribe((result) => {

        let arrayPartnerTrue: any[] = []
        let arrayPartnerFalse: any[] = []

        result.forEach((item) => {

          if (item.payload.doc.data().partner) {

            let categoryPrice = new CategoryPrice();
            categoryPrice.id = item.payload.doc.id;
            categoryPrice.partner = item.payload.doc.data().partner;
            categoryPrice.name = item.payload.doc.data().name;
            categoryPrice.product_id = item.payload.doc.data().product_id;
            categoryPrice.lot_id = item.payload.doc.data().lot_id;
            categoryPrice.value = item.payload.doc.data().value;
            categoryPrice.value_pix = item.payload.doc.data().value_pix;
            categoryPrice.value_defaulting = item.payload.doc.data().value_defaulting;
            categoryPrice.show_on_site = item.payload.doc.data().show_on_site;
            categoryPrice.requires_doc = item.payload.doc.data().requires_doc;
            categoryPrice.list_doc = item.payload.doc.data().list_doc;
            categoryPrice.foreigners_only = item.payload.doc.data().foreigners_only;
            categoryPrice.categories = item.payload.doc.data().categories;

            arrayPartnerTrue.push(categoryPrice)
          } else {
            let categoryPrice = new CategoryPrice();
            categoryPrice.id = item.payload.doc.id;
            categoryPrice.partner = item.payload.doc.data().partner;
            categoryPrice.name = item.payload.doc.data().name;
            categoryPrice.product_id = item.payload.doc.data().product_id;
            categoryPrice.lot_id = item.payload.doc.data().lot_id;
            categoryPrice.value = item.payload.doc.data().value;
            categoryPrice.value_defaulting = item.payload.doc.data().value_defaulting;
            categoryPrice.value_pix = item.payload.doc.data().value_pix;
            categoryPrice.show_on_site = item.payload.doc.data().show_on_site;

            categoryPrice.requires_doc = item.payload.doc.data().requires_doc;
            categoryPrice.list_doc = item.payload.doc.data().list_doc;

            categoryPrice.foreigners_only = item.payload.doc.data().foreigners_only;
            categoryPrice.categories = item.payload.doc.data().categories;

            arrayPartnerFalse.push(categoryPrice)
          }

        })

        arrayPartnerTrue.sort(this.compareNames)
        arrayPartnerFalse.sort(this.compareNames)

        this.productCatPricePartnerTrueDataSource = new MatTableDataSource(arrayPartnerTrue);
        this.productCatPricePartnerFalseDataSource = new MatTableDataSource(arrayPartnerFalse);

      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Load ProductItens error", '', 'error');
        })
  }

  loadCatPrices(product_id: any, lot_id: any) {

    return this.db.collection<CategoryPrice>('sbccv_product_cat_price', ref => ref
      .where('product_id', '==', product_id)
      .where('lot_id', '==', lot_id)).get()

  }

  compareNames(a, b) {

    const pa = String(a.name)
    const pb = String(b.name)

    if (pa > pb) return 1;
    if (pb > pa) return -1;

    return 0;
  }

  selectById(id) {
    this.itemDoc = this.db.doc<CategoryPrice>('sbccv_product_cat_price/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  insert(entity: CategoryPrice) {
    delete entity.id;
    return this.db.collection('sbccv_product_cat_price').add(Object.assign({}, entity));
  }

  update(entity: CategoryPrice) {
    let id = entity.id;
    delete entity.id;
    return this.db.collection('sbccv_product_cat_price').doc(id).set(Object.assign({}, entity));
  }

  delete(entity_id: any) {
    return this.db.collection('sbccv_product_cat_price').doc(entity_id).delete();
  }

  makeMsgError(errorsCode) {
    let msgError: string

    msgError = errorsCode

    return msgError
  }

}

